import type { PaletteMode } from '@mui/material';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface ThemeNameState {
  themeName: PaletteMode;
  toggleTheme: () => void;
}

export const useThemeNameStore = create<ThemeNameState>()(
  devtools(
    persist(
      (set, get) => ({
        themeName: window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light',
        toggleTheme: () =>
          set({ themeName: get().themeName === 'light' ? 'dark' : 'light' }),
      }),
      {
        name: 'theme',
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
